import type { FC, ReactElement, ReactNode } from 'react';
import { Children, Fragment, createElement } from 'react';

import type { IDivider } from '../../Divider/Divider';

import { Divider } from '../../';

export interface IList {
  children: ReactNode;
  tag?: 'div' | 'section' | 'aside';
  separator?: ReactNode;
  firstSeparator?: boolean;
  lastSeparator?: boolean;
  className?: string;
  id?: string;
  divider?: IDivider;
}

const BlocksList: FC<IList> = (props: IList): ReactElement => {
  const {
    tag = 'div',
    separator,
    firstSeparator = false,
    lastSeparator = false,
    className,
    id,
    divider,
  } = props;
  const children = Children.toArray(props.children);

  const blockProps = {
    className: className,
    id: id,
  };

  const _separator = separator || (
    <Divider theme={divider?.theme ?? 'fullToLine'} spacing={divider?.spacing ?? 1.5} />
  );

  const blockContent = (
    <Fragment>
      {firstSeparator && _separator}
      {children.map((child, i) => {
        if (i < children.length - 1) {
          return (
            <Fragment key={i}>
              {child}
              {_separator}
            </Fragment>
          );
        }
        return child;
      })}
      {lastSeparator && _separator}
    </Fragment>
  );

  return createElement(tag, blockProps, blockContent);
};

export default BlocksList;
